// extracted by mini-css-extract-plugin
export default {"menu_container":"Menu_menu_container__Yq+8b","menu":"Menu_menu__Uhlq1"};